/**
 * Net asgari ücret dönem tablosu (TL / ay).
 * Kaynak: Asgari Ücret Tespit Komisyonu / CSGB açıklamaları.
 * Yeni dönem eklendiğinde diziye satır eklemek yeterlidir (baslangiç artan sırada).
 */
export const ASGARI_NET_DONEMLER = [
  // --- 2019 öncesi (2026-09-03'te eklendi) ---
  // ÖNCEDEN TABLO 2019'DA BAŞLIYORDU. Daha eski bir tarih sorulduğunda
  // getAsgariNet sessizce ilk satırı (2019 değerini) döndürüyordu; örneğin
  // 2014 kazası için 846 TL yerine 2.020,90 TL kullanılıyor, geçmiş dönem
  // tazminatı ~2,4 kat şişiyordu. Aşağıdaki değerler resmî tablodan alındı.
  //
  // DİKKAT — AGİ: 2022 öncesi "net asgari ücret" rakamları asgari geçim
  // indirimi DAHİL yayımlanır (2019 için 191,88 TL AGİ dahildir). 2022'den
  // itibaren gelir vergisi istisnası nedeniyle AGİ uygulaması kalkmıştır.
  // Bilirkişi uygulamanız AGİ hariç net istiyorsa bu satırlardan AGİ
  // tutarlarını düşmeniz gerekir.
  { baslangic: '2009-01-01', net: 527.13, brut: 666.00 },
  { baslangic: '2009-07-01', net: 546.48, brut: 693.00 },
  { baslangic: '2010-01-01', net: 576.57, brut: 729.00 },
  { baslangic: '2010-07-01', net: 599.12, brut: 760.50 },
  { baslangic: '2011-01-01', net: 629.96, brut: 796.50 },
  { baslangic: '2011-07-01', net: 658.95, brut: 837.00 },
  { baslangic: '2012-01-01', net: 701.13, brut: 886.50 },
  { baslangic: '2012-07-01', net: 739.79, brut: 940.50 },
  { baslangic: '2013-01-01', net: 773.01, brut: 978.60 },
  { baslangic: '2013-07-01', net: 803.68, brut: 1021.50 },
  { baslangic: '2014-01-01', net: 846.00, brut: 1071.00 },
  { baslangic: '2014-07-01', net: 891.03, brut: 1134.00 },
  { baslangic: '2015-01-01', net: 949.07, brut: 1201.50 },
  { baslangic: '2015-07-01', net: 1000.54, brut: 1273.50 },
  { baslangic: '2016-01-01', net: 1300.99, brut: 1647.00 },
  { baslangic: '2017-01-01', net: 1404.06, brut: 1777.50 },
  { baslangic: '2018-01-01', net: 1603.12, brut: 2029.50 },
  // --- 2019 ve sonrası ---
  { baslangic: '2019-01-01', net: 2020.90, brut: 2558.40 },
  { baslangic: '2020-01-01', net: 2324.71, brut: 2943.00 }, // ÇSGB 2020 tablosu: 2.324,71 (AGİ 220,725 yukarı yuvarlanmış: 220,73)
  { baslangic: '2021-01-01', net: 2825.90, brut: 3577.50 },
  { baslangic: '2022-01-01', net: 4253.40, brut: 5004.00 },
  { baslangic: '2022-07-01', net: 5500.35, brut: 6471.00 },
  { baslangic: '2023-01-01', net: 8506.80, brut: 10008.00 },
  { baslangic: '2023-07-01', net: 11402.32, brut: 13414.50 },
  { baslangic: '2024-01-01', net: 17002.12, brut: 20002.50 },
  { baslangic: '2025-01-01', net: 22104.67, brut: 26005.50 },
  { baslangic: '2026-01-01', net: 28075.50, brut: 33030.00 },
];

function parseDay(value) {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [y, m, d] = value.slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Tablonun kapsadığı en eski tarih. */
export const ASGARI_TABLO_BASLANGIC = ASGARI_NET_DONEMLER[0].baslangic;

/**
 * Verilen tarih tablonun kapsamı dışında (çok eski) mı?
 * Böyle bir tarihte getAsgariNet en eski satırı döndürür — yani sonuç
 * OLDUĞUNDAN YÜKSEK çıkar. Ekranlar bu fonksiyonla kullanıcıyı uyarabilir.
 */
export function asgariUcretKapsamDisiMi(date) {
  const d = parseDay(date);
  const ilk = parseDay(ASGARI_TABLO_BASLANGIC);
  if (!d || !ilk) return false;
  return d.getTime() < ilk.getTime();
}

/** Verilen tarihte geçerli net asgari ücret (aylık). */
export function getAsgariNet(date) {
  const d = parseDay(date);
  if (!d) {
    const last = ASGARI_NET_DONEMLER[ASGARI_NET_DONEMLER.length - 1];
    return last ? last.net : 0;
  }
  // Tablo öncesi tarihlerde sessizce en eski değeri kullanmak, hesabı
  // olduğundan yüksek gösterir. Sessiz kalmak yerine geliştirme
  // ortamında uyaralım; ekranlar asgariUcretKapsamDisiMi() ile
  // kullanıcıya da bildirebilir.
  if (asgariUcretKapsamDisiMi(d) && typeof console !== 'undefined') {
    console.warn(
      `[asgariUcret] ${date} tarihi tablonun kapsamı dışında ` +
      `(tablo ${ASGARI_TABLO_BASLANGIC} tarihinde başlıyor). ` +
      `En eski dönem değeri kullanıldı; sonuç olduğundan yüksek olabilir.`
    );
  }
  let chosen = ASGARI_NET_DONEMLER[0];
  for (const row of ASGARI_NET_DONEMLER) {
    const b = parseDay(row.baslangic);
    if (b && b.getTime() <= d.getTime()) chosen = row;
  }
  return chosen ? Number(chosen.net) || 0 : 0;
}

/**
 * 2022 öncesi net asgari ücretin içindeki bekâr AGİ tutarı (ÇSGB tabloları;
 * yıl içinde ücret artsa da AGİ yıl başı tutarında kalır). 2022'den itibaren
 * AGİ yok. Yargıtay: aktif dönemde AGİ dahil, PASİF dönemde AGİ hariç net
 * (17. HD 08.05.2019, 2016/13219 E. 2019/5773 K.; 21. HD 18.03.2019,
 * 2018/3421 E. 2019/2096 K.).
 */
export const BEKAR_AGI = {
  2009: 49.95, 2010: 54.68, 2011: 59.74, 2012: 66.49, 2013: 73.40, 2014: 80.33, 2015: 90.11,
  2016: 123.53, 2017: 133.31, 2018: 152.21, 2019: 191.88, 2020: 220.73, 2021: 268.31,
};

/**
 * Verilen tarihte geçerli BRÜT asgari ücret (aylık). Bakıcı gideri brüt
 * üzerinden istenirse kullanılır (Yargıtay 10. HD 01.03.2022, 2021/8739 E.
 * 2022/2727 K.; içtihat net/brüt konusunda çelişkili). Kaynak: ÇSGB "asgari
 * ücretin net hesabı ve işverene maliyeti" yıllar tablosu, 2026: RG 26.12.2025/33119.
 */
export function getAsgariBrut(date) {
  const d = parseDay(date);
  let chosen = ASGARI_NET_DONEMLER[0];
  if (d) {
    for (const row of ASGARI_NET_DONEMLER) {
      const b = parseDay(row.baslangic);
      if (b && b.getTime() <= d.getTime()) chosen = row;
    }
  } else {
    chosen = ASGARI_NET_DONEMLER[ASGARI_NET_DONEMLER.length - 1];
  }
  return chosen ? Number(chosen.brut) || 0 : 0;
}

/** Pasif dönem için AGİ hariç net asgari ücret (2022 ve sonrasında net ile aynı). */
export function getAsgariNetAgiHaric(date) {
  const d = parseDay(date);
  const net = getAsgariNet(date);
  if (!d) return net;
  return Math.max(0, net - (BEKAR_AGI[d.getFullYear()] || 0));
}

/** Bugün geçerli net asgari. */
export function getGuncelAsgariNet() {
  return getAsgariNet(new Date());
}

/**
 * [start, end] aralığını asgari ücret dönemlerine böler.
 * Her dilim: { start, end, aylikNet, gun }
 */
export function asgariDonemDilimleri(startDate, endDate) {
  const start = parseDay(startDate);
  const end = parseDay(endDate);
  if (!start || !end || end.getTime() < start.getTime()) return [];

  const MS = 24 * 60 * 60 * 1000;
  const bounds = ASGARI_NET_DONEMLER.map((r) => parseDay(r.baslangic)).filter(Boolean);
  const points = [start.getTime()];
  for (const b of bounds) {
    const t = b.getTime();
    if (t > start.getTime() && t <= end.getTime()) points.push(t);
  }
  points.push(end.getTime() + MS); // end günü dahil (ertesi gün 00:00)

  const out = [];
  for (let i = 0; i < points.length - 1; i += 1) {
    const s = new Date(points[i]);
    const eExclusive = new Date(points[i + 1]);
    const e = new Date(eExclusive.getTime() - MS);
    if (e.getTime() < s.getTime()) continue;
    const gun = Math.round((e.getTime() - s.getTime()) / MS) + 1;
    out.push({
      start: s,
      end: e,
      aylikNet: getAsgariNet(s),
      gun,
    });
  }
  return out;
}
